'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosLocked = function IoIosLocked(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.1 17.5h4.4v18.8h-25v-18.8h4.4v-5.6c0-4.5 3.6-8.1 8.1-8.1s8.1 3.6 8.1 8.1v5.6z m-7.5 9.9c1.1-0.3 1.9-1.2 1.9-2.4 0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5c0 1.2 0.8 2.1 1.9 2.4v2.6h1.2v-2.6z m6.3-9.9v-5.6c0-3.9-3.1-6.9-6.9-6.9s-6.9 3-6.9 6.9v5.6h13.8z m-6.9 6.3c0.7 0 1.3 0.5 1.3 1.2s-0.6 1.3-1.3 1.3-1.2-0.6-1.2-1.3 0.5-1.2 1.2-1.2z' })
        )
    );
};

exports.default = IoIosLocked;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-locked.js
// module id = 2682
// module chunks = 168707334958949